import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Logger } from 'angular2-logger/core';

import { SharedService } from '../../../shared/shared.service';
import { ScheduleService } from '../schedule.service';
import { NgxSpinnerService } from 'ngx-spinner';

//  Jquery imports
declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-schedule-edit',
	templateUrl: './schedule-edit.component.html',
	styleUrls: ['./schedule-edit.component.scss']
})

export class ScheduleEditComponent implements OnInit {
	//public load : boolean;
	//public m_load : boolean;
	public form: FormGroup;
	public form2: FormGroup;
	public current_day: string;
	public schedule: any = {};
	public schedule_id: string;
	public day_helper = { 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday' };

	constructor(
		private _scheduleService: ScheduleService,
		private _sharedService: SharedService,
		private _router: Router,
		private _param: ActivatedRoute,
		private activatedRoute: ActivatedRoute,
		public toastr: ToastsManager,
		private logger: Logger,
		private fb: FormBuilder,
		private spinner: NgxSpinnerService
	) {
		this.schedule.monday = [];
		this.schedule.tuesday = [];
		this.schedule.wednesday = [];
		this.schedule.thursday = [];
		this.schedule.friday = [];
		this.schedule.saturday = [];
		this.schedule.sunday = [];

		// subscribe to router event
		this.activatedRoute.params.subscribe(params => {
			this.schedule_id = params['id'];
		});

		this.form = this.fb.group({
			name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]]
		});

		this.form2 = this.fb.group({
			start_hour: ['01', [Validators.required]],
			start_min: ['00', [Validators.required]],
			end_hour: ['01', [Validators.required]],
			end_min: ['00', [Validators.required]]
		});

	}

	ngOnInit() {
		this.spinner.show();
		//this.load = true;
		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			id: this.schedule_id
		};

		this._scheduleService.getSchedule(data).subscribe(
			data => {
				//this.load = false;
				this.spinner.hide();
				this.logger.log(data);
				if (data.status) {
					this.form.setValue({
						name: data.data.name
					});

					//saving the schedule
					for (let i = 0; i < data.data.schedules.length; i++) {
						let aux_day = this.day_helper[data.data.schedules[i].day_week];
						this.schedule[aux_day] = data.data.schedules[i].shift;
					}


				} else {
					this.toastr.error(data.message, 'Error');
				}

			},
			error => {
				//this.load = false;
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
				this.logger.log(error);

			}
		);

	}


	onEdit() {

		let aux = [];

		if (this.schedule.monday.length > 0) {
			aux.push({ day_week: 1, shift: this.schedule.monday });
		}
		if (this.schedule.tuesday.length > 0) {
			aux.push({ day_week: 2, shift: this.schedule.tuesday });
		}
		if (this.schedule.wednesday.length > 0) {
			aux.push({ day_week: 3, shift: this.schedule.wednesday });
		}
		if (this.schedule.thursday.length > 0) {
			aux.push({ day_week: 4, shift: this.schedule.thursday });
		}
		if (this.schedule.friday.length > 0) {
			aux.push({ day_week: 5, shift: this.schedule.friday });
		}
		if (this.schedule.saturday.length > 0) {
			aux.push({ day_week: 6, shift: this.schedule.saturday });
		}
		if (this.schedule.sunday.length > 0) {
			aux.push({ day_week: 7, shift: this.schedule.sunday });
		}

		if (aux.length > 0) {

			//this.load = true;
			this.spinner.show();

			let data = {
				auth_token: this._sharedService.getCookie('auth_token'),
				name: this.form.value.name,
				id: this.schedule_id,
				schedules: aux
			};

			//this.logger.log(this.form.value);
			this._scheduleService.editSchedule(data).subscribe(
				data => {
					this.logger.log(data);
					if (data.status) {
						this.toastr.success('Horario guardado con éxito! ', ' ¡Éxito!');
						this.onCancelSchedule();
					} else {
						this.toastr.error(data.message, 'Error');
					}
					//this.load= false;
					this.spinner.hide();
				},
				error => {
					this.toastr.error('Ocurrió un error, inténtalo de nuevo ', ' Error');
					this.logger.log(error);
					//this.load= false;
					this.spinner.hide();
				}
			);
		} else {
			$('#dontSave').modal('toggle');
		}
	}

	onNewShift() {
		/// creates a new shift

		//this.m_load = true;
		this.spinner.show();
		var shift = {
			time_start: this.form2.value.start_hour + ':' + this.form2.value.start_min + ':00',
			time_end: this.form2.value.end_hour + ':' + this.form2.value.end_min + ':00'
		}
		var append = true;

		for (let i = 0; i < this.schedule[this.current_day].length; i++) { // searchs for duplicates

			if (this.schedule[this.current_day][i].time_start == shift.time_start && this.schedule[this.current_day][i].time_end == shift.time_end) {
				append = false;
				break;
			} else if (this.schedule[this.current_day][i].time_start == shift.time_start
				&& this.schedule[this.current_day][i].time_end !== shift.time_end) {

				$('#dontInsertTurn').modal('toggle');
				append = false;
				break;

			} else if (this.schedule[this.current_day][i].time_start !== shift.time_start
				&& this.schedule[this.current_day][i].time_end > shift.time_end ||
				this.schedule[this.current_day][i].time_end > shift.time_start) {

				$('#dontInsertTurnEnd').modal('toggle');
				append = false;
				break;

			} else if (this.schedule[this.current_day][i].time_start > shift.time_start) { //inserts the shift in order
				append = false;
				this.schedule[this.current_day].splice(i, 0, shift);
				break;
			}

		}

		if (append) { //inserts the shift at the end
			this.schedule[this.current_day].push(shift);
		}

		//this.m_load = false;
		this.spinner.hide();
		$('#shift-new').modal('toggle');

	}

	onDeleteShift(day: string, id: number) {

		this.schedule[day].splice(id, 1);


	}

	openCreateShift(id: string) {
		this.current_day = id;
		$('#shift-new').modal('toggle'); // open modal

	}

	onCancelSchedule() {
		this._router.navigate(['./admin/schedules/list']);
	}


}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/schedule/schedule-edit/schedule-edit.component.ts